/* eslint-disable quotes */
/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line import/no-unresolved
import introJs from "intro.js";
import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Flags, isFeatureEnabled, translate } from "../../../../../providers";
import { isNonEmptyArray } from "../../../../../utils";
import { isElementPlaced } from "../../../utils/utils";

const SearchTour = ({ activatedTour, currentTour, onClose, onCompleteTour }) => {
	const introRef = useRef(null);
	const startingProductTourDocumentId = useSelector(({ context }) => context.startingProductTourDocumentId);
	const navigate = useNavigate();
	const handleOpenSideDrawer = (open) => {
		const targetBtn = document.querySelector(
			`div[class^="SideDrawerMain_layout__drawer__"][data-open="${open}"] div span button`
		);
		if (targetBtn) {
			targetBtn.click();
		}
	};
	if (!introRef?.current) {
		introRef.current = introJs();
	}
	useEffect(
		() => {
			const searchMenuButton = Array.from(document.querySelectorAll("button")).find((btn) => {
				const span = btn.querySelector("span");
				return span && span.textContent.trim() === translate("navigation:project.search");
			});

			introRef.current.setOptions({
				disableInteraction: true,
				nextLabel: translate("common:btn.next"),
				prevLabel: translate("common:btn.previous"),
				doneLabel: translate("common:btn.finish"),
				exitOnEsc: false,
				exitOnOverlayClick: false,
				hidePrev: true,
				keyboardNavigation: false,
				helperElementPadding: 8,
				steps: [
					{
						step: 0,
						title: translate("common:product-tour.essential.search.step.1.title"),
						intro: translate("common:product-tour.essential.search.step.1.intro"),
						element: searchMenuButton,
						position: "bottom",
					},
					{
						step: 1,
						title: translate("common:product-tour.essential.search.step.2.title"),
						intro: translate("common:product-tour.essential.search.step.2.intro"),
						element:
							"div[class^='SmartSearchFilters_filters__wrapperContainer__'] div div div[class^='FiltersWrapper_largeSearchWrapper__']",
						flags: [Flags.SEARCH_BAR],
					},
					{
						step: 2,
						title: translate("common:product-tour.essential.search.step.3.title"),
						intro: translate("common:product-tour.essential.search.step.3.intro"),
						element: "div[class^='FiltersWrapper_innerWrapper__']",
					},
					{
						step: 3,
						title: translate("common:product-tour.essential.search.step.5.title"),
						intro: translate("common:product-tour.essential.search.step.5.intro"),
						element: "div[class^='SmartSearchResult_result__']",
					},
					{
						step: 4,
						title: translate("common:product-tour.essential.search.step.6.title"),
						intro: translate("common:product-tour.essential.search.step.6.intro"),
						element: 'div[class^="SideDrawerMain_layout__drawer__"] div',
						position: "bottom",
					},
					{
						step: 5,
						title: translate("common:product-tour.essential.search.step.7.title"),
						intro: translate("common:product-tour.essential.search.step.7.intro"),
					},
				].filter((step) => !step?.flags || (isNonEmptyArray(step.flags) && isFeatureEnabled(step.flags))),
				tooltipClass: "IntroJsClass",
				showBullets: false,
				showProgress: false,
				showStepNumbers: false,
			});
			introRef.current.onbeforechange(() => {
				setTimeout(() => introRef.current.refresh(), 100);
			});
			introRef.current.onafterchange(() => {
				const currentStepIndex = introRef.current._currentStep;
				const totalSteps = introRef.current._options.steps.length;
				const tooltipButtons = document.querySelector(".introjs-tooltipbuttons");
				if (!tooltipButtons) {
					return;
				}
				const existingCounter = tooltipButtons.querySelector(".custom-step-counter");
				if (existingCounter) {
					existingCounter.remove();
				}
				const counter = document.createElement("div");
				counter.className = "custom-step-counter";
				counter.textContent = translate("common:product-tour.steps", {
					current: currentStepIndex + 1,
					total: totalSteps,
				});
				tooltipButtons.insertBefore(counter, tooltipButtons.firstChild);
			});
			const handleExit = () => {
				onClose(currentTour);
				introRef.current = null;
			};
			introRef.current.onexit(() => {
				handleExit();
			});
			introRef.current.oncomplete((_, reason) => {
				if (reason === "done") {
					onCompleteTour(currentTour);
				}
				handleExit();
			});
			const intervalId = setInterval(() => {
				const targetDiv = document.getElementById("tour-search-filters");
				const tourCondition = startingProductTourDocumentId && isElementPlaced(targetDiv);
				if (tourCondition && activatedTour === currentTour.id) {
					handleOpenSideDrawer(true);
					clearInterval(intervalId);
					introRef.current.start();
				}
			}, 100);
			return () => {
				clearInterval(intervalId);
			};
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[
			navigate,
			introRef?.current,
			onClose,
			onCompleteTour,
			activatedTour,
			currentTour,
			startingProductTourDocumentId,
		]
	);
	return <></>;
};

export default SearchTour;
